import { InfoCircleTwoTone } from "@ant-design/icons";
import { Flex } from "antd";
import { GraphTooltip } from "components/GraphTooltip";

import { MonitorPriority } from "./MonitorSeverity";

export const PriorityTooltip = () => (
  <GraphTooltip
    title="Priority"
    width="500px"
    overlay={
      <Flex vertical gap="small">
        <div>
          <MonitorPriority monitor={{ priority: "CRITICAL" }} />
          &nbsp;Active security vulnerability; fix immediately
        </div>
        <div>
          <MonitorPriority monitor={{ priority: "HIGH" }} />
          &nbsp;Violation of best practices; may enable a security vulnerability
        </div>
        <div>
          <MonitorPriority monitor={{ priority: "MEDIUM" }} />
          &nbsp;Informational; use to further understand your security posture
        </div>
        <div>
          <MonitorPriority monitor={{ priority: "LOW" }} />
          &nbsp;No security risk; use to inventory your system
        </div>
      </Flex>
    }
  >
    <InfoCircleTwoTone />
  </GraphTooltip>
);
